import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { AuthorByline } from '../AuthorByline/AuthorByline';
import { AdvertiserDisclosure, PRODUCT_TYPES } from '../AdvertiserDisclosure/AdvertiserDisclosure';
import { Body } from '../Body/Body';
import { Box } from '../Box/Box';
import { EditorialStandards } from '../EditorialStandards/EditorialStandards';
import { Title } from '../Title/Title';
import styles from './ContentPageHeader.module.less';
export var ContentPageHeader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var advertiserDisclosureShouldDelay = props.advertiserDisclosureShouldDelay,
      advertiserDisclosureType = props.advertiserDisclosureType,
      authoringDate = props.authoringDate,
      authors = props.authors,
      category = props.category,
      enableAnalytics = props.enableAnalytics,
      hideAdvertiserDisclosure = props.hideAdvertiserDisclosure,
      hideAuthorByline = props.hideAuthorByline,
      hideEditorialStandards = props.hideEditorialStandards,
      synopsis = props.synopsis,
      title = props.title;
  var synopsisComponent = /*#__PURE__*/React.createElement(Box, {
    marginBottom: "3"
  }, typeof synopsis === 'string' ? /*#__PURE__*/React.createElement(Body, null, synopsis) : synopsis);
  return /*#__PURE__*/React.createElement("header", {
    className: styles.header,
    ref: ref
  }, !hideAdvertiserDisclosure && /*#__PURE__*/React.createElement("div", {
    className: classes(['margin-bottom-2', 'margin-bottom-4--wide'])
  }, /*#__PURE__*/React.createElement(AdvertiserDisclosure, {
    enableAnalytics: enableAnalytics,
    type: advertiserDisclosureType,
    shouldDelay: advertiserDisclosureShouldDelay
  })), category && /*#__PURE__*/React.createElement(Title, {
    size: "x-small" // We opt out of the default h3 to maintain
    // semantic heading relationship with the h1
    // of the title content
    ,
    component: "p",
    className: classes('margin-bottom-3--wide')
  }, category), /*#__PURE__*/React.createElement(Title, {
    className: classes('margin-bottom-3'),
    size: "x-large"
  }, title), synopsis && synopsisComponent, !hideAuthorByline && /*#__PURE__*/React.createElement("div", {
    className: classes('margin-bottom-3')
  }, /*#__PURE__*/React.createElement(AuthorByline, {
    authoringDate: authoringDate,
    authors: authors
  })), !hideEditorialStandards && /*#__PURE__*/React.createElement(EditorialStandards, null));
});
ContentPageHeader.displayName = 'ContentPageHeader';
ContentPageHeader.defaultProps = {
  advertiserDisclosureType: PRODUCT_TYPES.CREDIT_CARDS,
  category: null,
  enableAnalytics: false,
  hideAdvertiserDisclosure: false,
  hideAuthorByline: false,
  hideEditorialStandards: false,
  synopsis: null
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  ContentPageHeader.propTypes = {
    /**
     * Type of messaging the advertiser disclosure will render. Currently
     * supports "investing" or the default. See the
     * AdvertiserDisclosure propTypes for more information.
     */
    advertiserDisclosureType: PropTypes.oneOf([PRODUCT_TYPES.CREDIT_CARDS, PRODUCT_TYPES.INVESTING]),

    /**
     * 1 or more authors that will be rendered (as a Type or optional Link)
     * in the byline.
     */
    authors: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string
    })).isRequired,

    /**
     * Accepts an ISO 8601 date string. Will be formatted to:
     *
     * Month date, year - eg. January 27, 2020
     */
    authoringDate: PropTypes.string.isRequired,

    /**
     * Content category.
     */
    category: PropTypes.string,

    /**
     * Flag indicating whether or not to enable bedrock analytics tracking.
     */
    enableAnalytics: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
      onClick: PropTypes.bool,
      onHover: PropTypes.bool
    })]),

    /**
     * Flag indicating whether or not to show the AdvertiserDisclosure component.
     */
    hideAdvertiserDisclosure: PropTypes.bool,

    /**
     * Flag indicating whether or not to show the author by line
     */
    hideAuthorByline: PropTypes.bool,

    /**
     * Flag indicating whether or not to show the EditorialStandards component.
     */
    hideEditorialStandards: PropTypes.bool,

    /**
     * Title content string.
     */
    title: PropTypes.string.isRequired,

    /**
     * Synopsis (main body).
     */
    synopsis: PropTypes.oneOfType([PropTypes.node, // Yes, string is a subset of the node type, but we treat strings
    // specially, so call it out specifically here.
    PropTypes.string])
  };
}